import type { CSSProperties, FC } from 'react';
export const Skeleton: FC<SkeletonProps> = ({
  className,
  style
}) => <div data-testid="skeleton" aria-live="polite" aria-busy="true" className={className} style={style} data-sentry-component="Skeleton" data-sentry-source-file="index.tsx">
    <span className="inline-flex w-full animate-pulse select-none rounded-md bg-gray-300 leading-none"></span>
    <br />
  </div>;
export const SVGSkeleton: FC<SkeletonProps> = ({
  className,
  style
}) => <svg data-testid="svg-skeleton" className={className + ' animate-pulse rounded bg-gray-300'} style={style} data-sentry-element="svg" data-sentry-component="SVGSkeleton" data-sentry-source-file="index.tsx" />;
type SkeletonProps = {
  className: string;
  style?: CSSProperties;
};